import { useCallback, useEffect, useState } from "react";

export function usePins(userId) {
  const [pinnedIds, setPinnedIds] = useState([]);

  const getPinnedKey = useCallback(() => `sis:pinned:${userId}`, [userId]);

  const togglePinConversation = useCallback((conversationId) => {
    setPinnedIds((prev) => {
      const updated = prev.includes(conversationId)
        ? prev.filter((id) => id !== conversationId)
        : [...prev, conversationId];

      localStorage.setItem(getPinnedKey(), JSON.stringify(updated));
      return updated;
    });
  }, [getPinnedKey]);

  useEffect(() => {
    if (!userId) return;

    try {
      setPinnedIds(JSON.parse(localStorage.getItem(getPinnedKey())) || []);
    } catch {
      setPinnedIds([]);
    }
  }, [getPinnedKey, userId]);

  return {
    pinnedIds,
    togglePinConversation,
  };
}
